import React, { useCallback, useState } from 'react'
import { ArrowRightOutlined, UsergroupAddOutlined } from '@ant-design/icons'

import IntlMessages from '../../util/IntlMessages'
import { trackOnboardingCallCtaClick } from './track-onboarding-call-cta'
import { useOnboardingCallCtaVariant } from './use-onboarding-call-cta-variant'
import { useOnboardingCallCtaBooked } from './use-onboarding-call-cta-booked'
import { OnboardingCallCalendlyEmbedModal } from './OnboardingCallCalendlyEmbedModal'
import './onboarding-call-cta.less'

interface ProfileMenuOnboardingCallCtaProps {
  companyId?: string
  userId?: string
}

export const ProfileMenuOnboardingCallCta: React.FC<ProfileMenuOnboardingCallCtaProps> = ({ companyId, userId }) => {
  const abVariant = useOnboardingCallCtaVariant()
  const booked = useOnboardingCallCtaBooked(userId, companyId)
  const [calendlyOpen, setCalendlyOpen] = useState(false)

  const onClick = useCallback(() => {
    trackOnboardingCallCtaClick({
      placement: 'profile_menu',
      abVariant,
      companyId,
      userId,
    })
    if (userId && companyId) {
      setCalendlyOpen(true)
    }
  }, [abVariant, companyId, userId])

  const closeCalendly = useCallback(() => setCalendlyOpen(false), [])

  if (booked) {
    return null
  }

  return (
    <div className="profile-menu-onboarding-cta">
      <button type="button" className="profile-menu-onboarding-cta__card" onClick={onClick}>
        <div className="profile-menu-onboarding-cta__icon" aria-hidden>
          <UsergroupAddOutlined />
        </div>
        <div className="profile-menu-onboarding-cta__text">
          <span className="profile-menu-onboarding-cta__badge">
            <IntlMessages id="onboarding.callCta.limitedOffer" />
          </span>
          <span className="profile-menu-onboarding-cta__title">
            <span className="profile-menu-onboarding-cta__title-line">
              <IntlMessages id="onboarding.callCta.titleLine1" />
            </span>
            <span className="profile-menu-onboarding-cta__title-line">
              <IntlMessages id="onboarding.callCta.titleLine2" />
            </span>
          </span>
        </div>
        <ArrowRightOutlined className="profile-menu-onboarding-cta__arrow" aria-hidden />
      </button>
      {userId && companyId ? <OnboardingCallCalendlyEmbedModal open={calendlyOpen} onClose={closeCalendly} placement="profile_menu" userId={userId} companyId={companyId} /> : null}
    </div>
  )
}
